module.exports = __webpack_public_path__ + "static/media/servingca.50cd6866.svg";